var _style, _defs, _defs2, _g, _defs3, _defs4, _g2, _defs5, _defs6, _defs7, _g3, _defs8, _defs9, _g4, _defs10, _defs11, _g5, _defs12, _defs13, _g6, _defs14, _defs15, _g7, _defs16, _g8, _defs17, _defs18, _g9, _defs19, _defs20, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350.2 110",
    style: {
      enableBackground: "new 0 0 350.2 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{fill:#F36B3C;}\n\t.st3{clip-path:url(#SVGID_6_);}\n\t.st4{clip-path:url(#SVGID_8_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_10_);}\n\t.st7{clip-path:url(#SVGID_12_);}\n\t.st8{clip-path:url(#SVGID_14_);}\n\t.st9{clip-path:url(#SVGID_16_);}\n\t.st10{clip-path:url(#SVGID_18_);}\n\t.st11{clip-path:url(#SVGID_20_);}\n\t.st12{clip-path:url(#SVGID_22_);}\n\t.st13{clip-path:url(#SVGID_24_);}\n\t.st14{clip-path:url(#SVGID_26_);}\n\t.st15{clip-path:url(#SVGID_28_);}\n\t.st16{clip-path:url(#SVGID_30_);}\n\t.st17{clip-path:url(#SVGID_32_);}\n\t.st18{clip-path:url(#SVGID_34_);}\n\t.st19{clip-path:url(#SVGID_36_);}\n\t.st20{clip-path:url(#SVGID_38_);}\n\t.st21{clip-path:url(#SVGID_40_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "5,5 5,105 295.1,105 295.1,105 345.2,55 295.1,5   "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -90,
    y: -2602,
    width: 1440,
    height: 3600
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 350.2,
    height: 110
  })))))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M44.9,58.1v14.3h-6.7V37.7h14.7c3.5,0,6.3,0.9,8.1,2.8c1.9,2,3,4.7,2.8,7.5c0.1,2.3-0.6,4.6-1.9,6.5    c-1.4,1.8-3.4,3-5.6,3.4L65,72.4h-7.6l-8.4-14.3L44.9,58.1z M57.2,48c0.1-1.1-0.4-2.1-1.1-2.8c-0.9-0.7-1.9-1-3-0.9h-8.1v7.4H53    c1.1,0,2.1-0.3,3-1C56.8,50,57.2,49,57.2,48z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -90,
    y: -2602,
    width: 1440,
    height: 3600
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.2,
    y: 32.7,
    className: "st5",
    width: 36.8,
    height: 44.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 5,
    y: 5,
    width: 340.1,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 70,
    y: 37,
    width: 214,
    height: 36
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 70.8,
    y: 37.7,
    width: 6.7,
    height: 34.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 32.7,
    className: "st5",
    width: 16.7,
    height: 44.7
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_15_",
    points: "137.2,37.7 143.8,37.7 143.8,72.4 137.2,72.4 137.2,58.2 124.2,58.2 124.2,72.4 117.6,72.4          117.6,37.7 124.2,37.7 124.2,51.6 137.2,51.6        "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 5,
    y: 5,
    width: 341,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.6,
    y: 32.7,
    className: "st5",
    width: 36.2,
    height: 44.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_19_",
    points: "165.4,44.3 165.4,72.4 158.5,72.4 158.5,44.3 148.9,44.3 148.9,37.7 175.1,37.7 175.1,44.3                 "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 5,
    y: 5,
    width: 341,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.9,
    y: 32.7,
    className: "st5",
    width: 36.2,
    height: 44.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M191.2,72.9c-1.8,0-3.5-0.3-5.2-0.8c-1.5-0.5-2.8-1.3-4-2.3c-1.1-1-2-2.2-2.6-3.6         c-0.6-1.5-1-3.1-1.1-4.7h6.9c0.1,1.4,0.8,2.7,1.9,3.6c1.2,0.9,2.6,1.4,4.1,1.3c1.3,0.1,2.5-0.2,3.6-0.9         c0.9-0.6,1.4-1.6,1.4-2.6c0-0.9-0.3-1.7-0.9-2.3c-0.8-0.7-1.7-1.1-2.7-1.4l-5.9-1.6c-4.9-0.9-8.3-5.3-8-10.3         c0-1.5,0.3-3.1,0.9-4.5c0.6-1.2,1.5-2.3,2.5-3.2c1.1-0.9,2.3-1.5,3.7-1.9c1.4-0.4,2.9-0.6,4.4-0.6c1.6,0,3.2,0.2,4.7,0.7         c1.3,0.4,2.6,1.1,3.6,2c1,0.9,1.9,1.9,2.5,3.1c0.6,1.3,1,2.7,1.2,4.1h-6.9c-0.3-1.1-1-2-2-2.6c-1-0.5-2.1-0.8-3.3-0.8         c-1.2,0-2.4,0.2-3.4,0.8c-0.9,0.6-1.4,1.6-1.3,2.7c-0.1,0.9,0.3,1.7,1,2.3c0.7,0.5,1.6,0.9,2.5,1.1l5.7,1.5         c2.4,0.5,4.5,1.8,6.1,3.6c1.5,2,2.3,4.5,2.1,6.9c0.1,2.8-0.9,5.5-3,7.4C197.9,72,195,72.9,191.2,72.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 5,
    y: 5,
    width: 341,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 32.2,
    className: "st5",
    width: 34.5,
    height: 45.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_27_",
    points: "228.2,37.7 234.9,37.7 234.9,72.4 228.2,72.4 228.2,58.2 215.3,58.2 215.3,72.4 208.7,72.4          208.7,37.7 215.3,37.7 215.3,51.6 228.2,51.6        "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 5,
    y: 5,
    width: 341,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.7,
    y: 32.7,
    className: "st5",
    width: 36.2,
    height: 44.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 242.7,
    y: 37.7,
    width: 6.7,
    height: 34.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 32.7,
    className: "st5",
    width: 16.7,
    height: 44.7
  })))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M263.7,72.4h-6.6V37.7h14.2c1.8,0,3.7,0.3,5.4,1c1.4,0.6,2.7,1.5,3.8,2.6c1,1.1,1.7,2.4,2.2,3.8         c0.5,1.5,0.7,3,0.7,4.6c0,1.5-0.2,3.1-0.7,4.5c-0.5,1.4-1.2,2.7-2.2,3.9c-1,1.2-2.3,2.1-3.8,2.7c-1.7,0.7-3.5,1-5.4,1h-7.5         L263.7,72.4z M271.3,55.2c0.8,0,1.6-0.1,2.4-0.5c1.3-0.6,2.2-1.7,2.7-3c0.2-0.6,0.3-1.3,0.3-2c0-0.7-0.1-1.4-0.3-2         c-0.2-0.6-0.6-1.2-1-1.7c-0.5-0.5-1-0.9-1.7-1.2c-0.8-0.3-1.6-0.5-2.4-0.5h-7.5v10.9L271.3,55.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: 5,
    y: 5,
    width: 341,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.1,
    y: 32.7,
    className: "st5",
    width: 36.2,
    height: 44.7
  })))))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M97.9,59.2h6.5v0.9c0.1,1.7-0.6,3.5-1.9,4.6c-2.7,2.2-6.5,2.2-9.2,0c-1.3-1.2-2-2.9-1.9-4.6v-10         c-0.1-1.8,0.6-3.5,1.9-4.6c1.3-1.1,2.9-1.7,4.6-1.6c1.5,0,2.9,0.4,4.1,1.2c0.8,0.5,1.4,1.3,1.8,2.1h7c-0.2-1.1-0.5-2.2-1-3.2         c-0.6-1.4-1.5-2.6-2.6-3.6c-1.2-1-2.5-1.8-4-2.3c-1.7-0.6-3.5-0.8-5.3-0.8c-1.9,0-3.8,0.3-5.6,0.9c-1.5,0.6-3,1.5-4.1,2.6         c-1.1,1.1-2,2.5-2.6,4.1c-0.6,1.7-0.9,3.5-0.9,5.3v10c0,1.8,0.3,3.6,0.9,5.3c0.5,1.5,1.4,2.9,2.6,4.1c1.2,1.2,2.6,2,4.1,2.6         c3.6,1.2,7.5,1.2,11.1,0c1.5-0.6,3-1.5,4.1-2.6c1.1-1.1,2-2.5,2.6-4.1c0.6-1.7,0.9-3.5,0.9-5.3v-7.5H97.9V59.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: 5,
    y: 5,
    width: 341,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.8,
    y: 32.2,
    className: "st5",
    width: 36.2,
    height: 45.7
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightShip);
export default __webpack_public_path__ + "static/media/right-ship.9e84170d854befff8b38a3a0f1b68ff9.svg";
export { ForwardRef as ReactComponent };